/**
 * 全角字符
 */
export const SBC_CASE = ['，', '。', '–', '、', '‘', '’', '“', '”', '；', '×', '￥', '·', '！', '＃', '＄', '％', '＆', '＇', '（', '）', '＊', '＋', '，', '－', '／',
  '０', '１', '２', '３', '４', '５', '６', '７', '８', '９', '：', '；', '＜', '＝', '＞', '？', '＠', 'Ａ', 'Ｂ', 'Ｃ', 'Ｄ', 'Ｅ', 'Ｆ', 'Ｇ', 'Ｈ', 'Ｉ', 'Ｊ', 'Ｋ', 'Ｌ', 'Ｍ', 'Ｎ', 'Ｏ', 'Ｐ',
  'Ｑ', 'Ｒ', 'Ｓ', 'Ｔ', 'Ｕ', 'Ｖ', 'Ｗ', 'Ｘ', 'Ｙ', 'Ｚ', '［', '］', '＾', '＿', '｀', 'ａ', 'ｂ', 'ｃ', 'ｄ', 'ｅ', 'ｆ', 'ｇ', 'ｈ', 'ｉ', 'ｊ', 'ｋ', 'ｌ', 'ｍ', 'ｎ', 'ｏ', 'ｐ', 'ｑ', 'ｒ',
  'ｓ', 'ｔ', 'ｕ', 'ｖ', 'ｗ', 'ｘ', 'ｙ', 'ｚ', '｛', '｜', '｝', '～', '　', ' ']

/**
 * 半角字符
 */
export const DBC_CASE = [',', '.', '-', '/', "'", "'", '"', '"', ';', '*', '$', '`', '!', '#', '$', '%', '&', '"', '(', ')', '*', '+', ',', '-', '/', '0', '1', '2', '3',
  '4', '5', '6', '7', '8', '9', ':', ';', '<', '=', '>', '?', '@', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '[',
  ']', '^', '_', '`', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '{', '|', '}', '~', ' ', ' ']

export const ABC_US = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export const ABC_US2 = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
export const NUM = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
export const SYMBOL = [',', '.', '/', '*', '-', '+', ':', ' ', '(', ')']

export const S_CHAR = ['\b', '\f', '']

export const SINGLE_NUM_ARR = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE']

export const TEN_NUM_ARR = ['TEN', 'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN']

export const TEN_INTEGER_ARR = ['TEN', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY']

export const EXTERNAL_USER = -100

export const SPECIAL_CHARACTER = ['À', 'Á', 'Â', 'Ä', 'à', 'á', 'â', 'ä', 'È', 'É', 'Ê', 'è', 'é', 'ê', 'ë', 'Ì', 'Í', 'Î', 'ì', 'í', 'î', 'ï', 'Ò', 'Ó', 'Ô', 'Ö', 'ò', 'ó',
  'ô', 'ö', 'Ù', 'Ú', 'Û', 'Ü', 'ù', 'ú', 'û', 'ü', 'Ç', 'ç', 'Ñ', 'ñ', '¿', '¡', '№']

class StrUtils {
  constructor() {

  }

  /**
   * return true:same
   * 如果数量不同,小数位数2或3,相差只有0.01或0.001也算相同
   */
  static NumberIsSame(number1, number2, fix) {
    if (number1 === number2) return true
    var str1 = number1.toFixed(fix)
    var str2 = number2.toFixed(fix)
    if (str1 === str2) return true
    if (fix > 1) {
      str1 = str1.substring(str1.length - 1)
      str2 = str2.substring(str2.length - 1)
      var i1 = parseInt(str1)
      var i2 = parseInt(str2)
      if (Math.abs(i1 - i2) === 1) return true
    }
    return false
  }

  static numberDx(number) {
    if (!number || number <= 0) return ''
    var numberstr = String(number)
    var numlen = numberstr.length
    var D = numberstr
    var dlen = D.length
    var tmpdlen = D.length
    var tmp = ''
    if (numlen === 5 || numlen === 2 || numlen === 8) {
      tmp = D.substr(0, 2)
    } else {
      tmp = D.substr(0, 1)
    }
    var K = ''
    var KK = ''
    var KKK = ''

    while (1 === 1) {
      if ((dlen === 1 && tmpdlen === 1) || tmpdlen === 3 || (dlen === 4 && tmpdlen === 4) || tmpdlen === 6 || tmpdlen === 7) {
        switch (tmp) {
          case '0':
            KK = ''
            break
          case '1':
            KK = ' ONE '
            break
          case '2':
            KK = ' TWO '
            break
          case '3':
            KK = ' THREE '
            break
          case '4':
            KK = ' FOUR '
            break
          case '5':
            KK = ' FIVE '
            break
          case '6':
            KK = ' SIX '
            break
          case '7':
            KK = ' SEVEN '
            break
          case '8':
            KK = ' EIGHT '
            break
          case '9':
            KK = ' NINE '
            break
        }
      } else {
        switch (tmp) {
          case '00':
            KK = ''
            break
          case '10':
            KK = ' TEN '
            break
          case '11':
            KK = ' ELEVEN '
            break
          case '12':
            KK = ' TWELVE '
            break
          case '13':
            KK = ' THIRTEEN '
            break
          case '14':
            KK = ' FOURTEEN '
            break
          case '15':
            KK = ' FIFTEEN '
            break
          case '16':
            KK = ' SIXTEEN '
            break
          case '17':
            KK = ' SEVENTEEN '
            break
          case '18':
            KK = ' EIGHTEEN '
            break
          case '19':
            KK = ' NINETEEN '
            break
          case '20':
            KK = ' TWENTY '
            break
          case '30':
            KK = ' THIRTY '
            break
          case '40':
            KK = ' FORTY '
            break
          case '50':
            KK = ' FIFTY '
            break
          case '60':
            KK = ' SIXTY '
            break
          case '70':
            KK = ' SEVENTY '
            break
          case '80':
            KK = ' EIGHTY '
            break
          case '90':
            KK = ' NINETY '
            break
          default:
            if (tmp.length === 2) {
              switch (tmp.substr(0, 1)) {
                case '0':
                  KK = ''
                  break
                case '2':
                  KK = ' TWENTY'
                  break
                case '3':
                  KK = ' THIRTY'
                  break
                case '4':
                  KK = ' FORTY'
                  break
                case '5':
                  KK = ' FIFTY'
                  break
                case '6':
                  KK = ' SIXTY'
                  break
                case '7':
                  KK = ' SEVENTY'
                  break
                case '8':
                  KK = ' EIGHTY'
                  break
                case '9':
                  KK = ' NINETY'
                  break
              }
              switch (tmp.substr(1, 1)) {
                case '1':
                  KKK = ' ONE '
                  break
                case '2':
                  KKK = ' TWO '
                  break
                case '3':
                  KKK = ' THREE '
                  break
                case '4':
                  KKK = ' FOUR '
                  break
                case '5':
                  KKK = ' FIVE '
                  break
                case '6':
                  KKK = ' SIX '
                  break
                case '7':
                  KKK = ' SEVEN '
                  break
                case '8':
                  KKK = ' EIGHT '
                  break
                case '9':
                  KKK = ' NINE '
                  break
              }
            }
            KK = KK + KKK
        }
      }
      switch (dlen) {
        case 8:
          switch (tmpdlen) {
            case 8:
              K = KK + 'MILLIONS'
              tmp = D.substr(2, 1)
              tmpdlen--
              break
            case 6:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(3, 2)
              tmpdlen--
              break
            case 4:
              K = K + KK + (tmp === '00' ? '' : 'THOUSAND')
              tmp = D.substr(5, 1)
              break
            case 3:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(6, 2)
              tmpdlen--
              break
            case 1:
              K = K + (tmp === '00' ? ' ' : ' AND' + KK)
              return K
          }
          tmpdlen--
          break
        case 7:
          switch (tmpdlen) {
            case 7:
              K = KK + 'MILLIONS'
              tmp = D.substr(1, 1)
              break
            case 6:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(2, 2)
              tmpdlen--
              break
            case 4:
              K = K + KK + (tmp === '00' ? '' : 'THOUSAND')
              tmp = D.substr(4, 1)
              break
            case 3:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(5, 2)
              tmpdlen--
              break
            case 1:
              K = K + (tmp === '00' ? ' ' : ' AND' + KK)
              return K
          }
          tmpdlen--
          break
        case 6:
          switch (tmpdlen) {
            case 6:
              K = K + KK + 'HUNDRED'
              tmp = D.substr(1, 2)
              tmpdlen--
              break
            case 4:
              K = K + KK + (tmp === '00' ? ' THOUSAND' : 'THOUSAND')
              tmp = D.substr(3, 1)
              break
            case 3:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(4, 2)
              tmpdlen--
              break
            case 1:
              K = K + (tmp === '00' ? ' ' : ' AND' + KK)
              return K
          }
          tmpdlen--
          break
        case 5:
          switch (tmpdlen) {
            case 5:
              K = K + KK + 'THOUSAND'
              tmp = D.substr(2, 1)
              tmpdlen--
              break
            case 3:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(3, 2)
              tmpdlen--
              break
            case 1:
              K = K + (tmp === '00' ? ' ' : ' AND' + KK)
              return K
          }
          tmpdlen--
          break
        case 4:
          switch (tmpdlen) {
            case 4:
              K = K + KK + 'THOUSAND'
              tmp = D.substr(1, 1)
              break
            case 3:
              K = K + KK + (tmp === '0' ? '' : 'HUNDRED')
              tmp = D.substr(2, 2)
              tmpdlen--
              break
            case 1:
              K = K + (tmp === '00' ? ' ' : ' AND' + KK)
              return K
          }
          tmpdlen--
          break
        case 3:
          switch (tmpdlen) {
            case 3:
              K = K + KK + 'HUNDRED'
              tmp = D.substr(1, 2)
              tmpdlen--
              break
            case 1:
              K = K + (tmp === '00' ? ' ' : ' AND' + KK)
              return K
          }
          tmpdlen--
          break
        case 2:
          K = KK
          return K
        case 1:
          K = KK
          return K
      }
    }
    return K
  }

  static jsdx(number, packing) {
    if (!number || number <= 0) return ''
    const numberStr = String(number)
    const tmp = this.parse(numberStr)
    if (packing === 'CTNS') {
      packing = 'CARTONS'
    } else if (packing === 'BALE' && number !== 1) {
      packing = 'BALES'
    } else if (packing === 'PCS') {
      packing = 'PIECES'
    }
    return 'SAY ' + tmp + packing + ' ONLY.'
  }

  static jsdx2(number) {
    if (!number || number <= 0.0) return ''
    var numberstr = String(number)
    return this.parse(numberstr)
  }

  static checkValue(object, msg) {
    if (object) {
      return true
    } else {
      Alert.show(msg, 'Error')
      return false
    }
  }

  static isEmpty(txt) {
    return !txt || String(txt).trim().length === 0
  }

  static getCurrencyChineseName(code) {
    var chineseName = ''
    switch (code) {
      case 'RMB':
        chineseName = '人民币'
        break
      case 'USD':
        chineseName = '美元'
        break
      case 'HKD':
        chineseName = '港币'
        break
      case 'IRR':
        chineseName = '伊朗里亚尔'
        break
      case 'JPY':
        chineseName = '日本元'
        break
      case 'KWD':
        chineseName = '科威特第纳尔'
        break
      case 'MOP':
        chineseName = '澳门元'
        break
      case 'MYR':
        chineseName = '马来西亚林吉特'
        break
      case 'PKR':
        chineseName = '巴基斯坦卢比'
        break
      case 'PHP':
        chineseName = '菲律宾比索'
        break
      case 'SGD':
        chineseName = '新加坡元'
        break
      case 'THB':
        chineseName = '泰国铢'
        break
      case 'TWD':
        chineseName = '台币'
        break
      case 'EUR':
        chineseName = '欧元'
        break
      case 'DKK':
        chineseName = '丹麦克朗'
        break
      case 'GBP':
        chineseName = '英镑'
        break
      case 'NOK':
        chineseName = '挪威克朗'
        break
      case 'SEK':
        chineseName = '瑞典克朗'
        break
      case 'CHF':
        chineseName = '瑞士法郎'
        break
      case 'SUR':
        chineseName = '苏联卢布'
        break
      case 'ASF':
        chineseName = '清算瑞士法郎'
        break
      case 'CAD':
        chineseName = '加拿大元'
        break
      case 'AUD':
        chineseName = '澳大利亚元'
        break
      case 'NZD':
        chineseName = '新西兰元'
        break
      case 'INR':
        chineseName = '印度卢比'
        break
      case 'WON':
        chineseName = '韩币'
        break
      case 'YEN':
        chineseName = '日元'
        break
      case 'IDR':
        chineseName = '印度尼西亚卢比'
        break
      case 'NTD':
        chineseName = '新台币'
        break
      case 'SAR':
        chineseName = '沙特里亚尔'
        break
    }
    return chineseName
  }

  /**
   * 将字符串变成红色
   */
  static getRedHtml(txt) {
    if (this.isEmpty(txt)) return ''
    return "<font color='#FF0000'>" + txt + '</font>'
  }

  /**
   * txt是否是某个重复的字符组成，如AAAAA是由A生成
   */
  static isRepeat(txt) {
    if (this.isEmpty(txt)) return false
    if (txt.length === 1) return true
    var t = txt.charAt(0)
    for (var i = 1, len = txt.length; i < len; i++) {
      if (txt.substr(i, 1) !== t) return false
    }
    return true
  }

  /**
   *  全角转半角
   */
  static toHalfword(txt, autoHalfword = true) {
    if (autoHalfword && !this.isEmpty(txt)) {
      for (var i = 0; i < SBC_CASE.length; i++) {
        var reg = new RegExp(SBC_CASE[i], 'g')
        txt = txt.replace(reg, DBC_CASE[i])
      }
    }
    return txt
  }

  /**
   * 排除特殊编码
   * @param t
   * @return
   */
  static replaceSpecialCharacter(t) {
    if (!this.isEmpty(t)) {
      for (var i = 0; i < S_CHAR.length; i++) {
        t = this.replaceAll(t, S_CHAR[i], '')
      }
    }
    return t
  }

  static toUpperCase(str) {
    if (!this.isEmpty(str)) {
      return str.toLocaleUpperCase()
    }
    return str
  }

  static toLowerCase(str) {
    if (!this.isEmpty(str)) {
      return str.toLocaleLowerCase()
    }
    return str
  }

  /**
   *  大写 全角转半角
   */
  static toHalfwordUpperCase(str) {
    if (!this.isEmpty(str)) {
      return this.toHalfword(str).toLocaleUpperCase()
    }
    return str
  }

  /**
   * 过滤空字符
   */
  static converEmptyToString(value) {
    if (value === null || value === '' || value === 'null') {
      return ''
    }
    return value
  }

  /**
   * 字符串又靠左补0
   */
  static strRightRepeat(str, n, value) {
    if (n === 0) {
      return ''
    }
    var s = ''
    for (var i = 1; i <= n - value.length; i++) {
      s += str
    }
    return s.concat(value)
  }

  /**
   * 字符串又靠又补0
   */
  static strLeftRepeat(str, n, value) {
    if (n === 0) {
      return ''
    }
    var s = ''
    for (var i = 1; i <= n - value.length; i++) {
      s += str
    }
    return value.concat(s)
  }

  /**
   * @export
   */
  static joinArrayPs(ps) {
    var vPs = ''
    for (var str in ps) {
      if (vPs.length > 0) { vPs += ',' }
      vPs += "'" + str + "'"
    }
    return vPs
  }

  /**
   * 判断一个字符串是否有中文
   */
  static isChinese(strName) {
    if (this.isEmpty(strName)) { return false }

    for (var i = 0; i < strName.length; i++) {
      var char = strName.substr(i, 1)
      if (/[^\x00-\xff]/g.test(char)) {
        return true
      }
    }
    return false
  }

  /**
   * 判断一个字符串是否有字母[a-z A-Z]
   */
  static isEnglish(strName) {
    if (this.isEmpty(strName)) { return false }

    for (var i = 0; i < strName.length; i++) {
      var char = strName.substr(i, 1)
      var code = char.charCodeAt(i)
      if (code >= 65 && code <= 90 || code >= 97 && code <= 112) {
        return true
      }
    }
    return false
  }

  static parse(x) {
    if (Number(x) <= 0) {
      return 'ZERO CENTS'
    }
    const z = x.indexOf('.') // 取小数点位置

    let lstr = ''
    let rstr = ''
    if (z > -1) { // 看是否有小数，如果有，则分别取左边和右边
      lstr = x.substring(0, z)
      rstr = x.substring(z + 1)
    } else { // 否则就是全部
      lstr = x
    }

    let lstrrev = this.reverse(lstr) // 对左边的字串取反
    const a = new Array(5) // 定义5个字串变量来存放解析出来的叁位一组的字串

    switch (lstrrev.length % 3) {
      case 1:
        lstrrev += '00'
        break
      case 2:
        lstrrev += '0'
        break
    }
    let lm = '' // 用来存放转换後的整数部分
    for (let i = 0; i < lstrrev.length / 3; i++) {
      a[i] = this.reverse(lstrrev.substring(3 * i, 3 * i + 3)) // 截取第一个叁位
      if (a[i] !== '000') { // 用来避免这种情况：1000000 = one million
        if (i !== 0) {
          lm = this.transThree(a[i]) + ' ' + this.parseMore(String(i)) + ' ' + lm // 加:
          // thousand、million、billion
        } else {
          lm = this.transThree(a[i])
        } // 防止i=0时， 在多加两个空格.
      } else {
        lm += this.transThree(a[i])
      }
    }

    let xs = '' // 用来存放转换後小数部分
    if (z > -1) {
      const transTwo = this.transTwo(rstr)
      if (!transTwo) {
        xs = ''
      } else {
        xs = 'AND ' + transTwo + ' CENTS ' // 小数部分存在时转换小数
      }
    }
    return lm.trim() + ' ' + xs
  }

  static parseFirst(s) {
    return SINGLE_NUM_ARR[Number(s.substring(s.length - 1))]
  }

  static parseTeen(s) {
    return TEN_NUM_ARR[parseInt(s) - 10]
  }

  static parseTen(s) {
    return TEN_INTEGER_ARR[parseInt(s.substring(0, 1)) - 1]
  }

  // 两位
  static transTwo(s) {
    let value = ''
    // 判断位数
    if (s.length > 2) { s = s.substring(0, 2) } else if (s.length < 2) { s = s + '0' }

    if (s.charAt(0) === '0') { // 07 - seven 是否小於10
      value = this.parseFirst(s)
    } else if (s.charAt(0) === '1') { // 17 seventeen 是否在10和20之间
      value = this.parseTeen(s)
    } else if (s.charAt(s.length - 1) === '0') { // 是否在10与100之间的能被10整除的数
      value = this.parseTen(s)
    } else {
      value = this.parseTen(s) + ' ' + this.parseFirst(s)
    }
    return value
  }

  static parseMore(s) {
    const a = ['', 'THOUSAND', 'MILLION', 'BILLION']
    return a[parseInt(s)]
  }

  //
  //		// 制作叁位的数
  //		// s.length = 3
  static transThree(s) {
    var value = ''
    if (s.charAt(0) === '0') { // 是否小於100
      value = this.transTwo(s.substring(1))
    } else if (s.substring(1) === '00') { // 是否被100整除
      value = this.parseFirst(s.substring(0, 1)) + ' HUNDRED'
    } else { value = this.parseFirst(s.substring(0, 1)) + ' HUNDRED AND ' + this.transTwo(s.substring(1)) }
    return value
  }

  static reverse(s) {
    var aChr = s.split('')
    var tmp = ''
    for (var i = aChr.length - 1; i >= 0; i--) {
      tmp += aChr[i]
    }
    return tmp
  }

  /**
   * 按指定长度分割地址
   */
  static getSliptCharLenStrs(str, maxChar) {
    var contents = []
    if (!StrUtils.isEmpty(str)) {
      // 把原始字符串分割成指定长度的字符串列表
      var size = str.length / maxChar
      if (str.length % maxChar !== 0) {
        size += 1
      }
      // 把原始字符串分割成指定长度的字符串列表
      for (var index = 0; index < size; index++) {
        var childStr = null
        if (index === 0) {
          childStr = this.substringft(str, index * maxChar, (index + 1) * maxChar)
        } else {
          childStr = this.substringft(str, index * maxChar - index + 1, (index + 1) * maxChar - index)
        }
        contents.addItem(childStr)
      }
    }
    return contents
  }

  /**
   * 分割字符串，如果开始位置大于字符串长度，返回空
   */
  static substringft(str, f, t) {
    // f:开始位置    t:结束位置
    if (f > str.length) { return null }
    if (t > str.length) {
      return str.substring(f, str.length)
    } else {
      return str.substring(f, t)
    }
  }

  /**
   * 传入一行文字 判断是否有特殊字符 加粗 并下划线处理
   *
   * 兼容旧字体变红、换行功能
   * @param tDo
   * @return
   */
  static identifyExceptionalCharacters(tDo) {
    var br = '<br/>'
    var tDo2 = ''
    // 第一步：检查是否是换行符号
    if (tDo === br) {
      return tDo
    }
    // 第二步：检查是否包含换行符号 一般在文本结尾；
    var isBr = false
    if (tDo.indexOf(br) > -1) {
      tDo2 = tDo.split(br)[0]
      isBr = true
    } else {
      tDo2 = tDo
    }
    var reStr = this.colorText(tDo2)

    if (isBr) {
      reStr += br
    }
    return reStr
  }

  /**
   * 处理字符变红
   * @param linStr 一段文本
   * @return
   */
  static colorText(linStr) {
    var s = '<font color="#ff0000">'
    var s2 = '</font>'
    var result = ''

    var w = []
    var l = linStr.split(s)
    w.push(l[0])
    if (l.length > 1) {
      var l2 = l[1].split(s2)
      w.push(l2[0])
    }
    for (var j = 0; j < w.length; j++) {
      var jStr = w[j]
      w[j] = this.doF(jStr)
    }
    if (w.length > 1) {
      result = w[0] + '<font color="#ff0000">' + w[1] + '</font>'
    } else {
      result = w[0]
    }
    return result
  }

  /**
   * 处理<转义符号
   * @param w 一段文本
   * @return
   */
  static doF(w) {
    var f = '&lt;'
    var F = '&LT;'
    var TF = '<font color="#3300ff"><u>&LT;</u></font>'
    var result = ''
    if (w === f || w === F) {
      return TF
    }
    w = this.replaceAll(w, f, F)
    var l = w.split(F)
    for (var j = 0; j < l.length; j++) {
      var jStr = l[j]
      result += this.doCharacters(jStr)
      if (j < l.length - 1) {
        result += TF
      }
    }
    return result
  }

  /**
   * @export
   */
  static replaceAll(source, find, replacement) {
    if (!source || typeof source !== 'string') return ''
    return source.split(find).join(replacement)
  }

  /**
   *  传入一行文字 判断是否有特殊字符 加粗 并下划线处理
   * @param jStr 一行文本
   * @return
   */
  static doCharacters(jStr) {
    var allList = ABC_US.concat(ABC_US2, NUM, SYMBOL)
    var c = false
    var result = ''
    for (var i = 0; i < jStr.length; i++) {
      var str = jStr.substring(i, i + 1)
      if (allList.indexOf(str) > -1) {
        var b = ''
        if (c) {
          b = '</u></font>'
          c = false
        }
        result += b + str
      } else {
        var a = ''
        if (!c) {
          a = '<font color="#3300ff"><u>'
          c = true
        }
        result += a + str
      }
    }
    if (c) {
      result += '</u></font>'
    }
    return result
  }
  static substitute(str, ...rest) {
    if (str == null) return ''
    // Replace all of the parameters in the msg string.
    let len = rest.length
    let args = []
    if (len === 1 && rest[0] instanceof Array) {
      args = rest[0]
      len = args.length
    } else {
      args = rest
    }
    for (let i = 0; i < len; i++) {
      str = str.replace(new RegExp('\\{' + i + '\\}', 'g'), args[i])
    }
    return str
  }
  static numberFormatFunc(value, fix = 2) {
    return value.toFixed(fix).toString()
  }

  /**
   * 是否含有特殊字符
   * @param strName
   * @returns {boolean}
   */
  static isContainSpecialCharacter(strName) {
    if (this.isEmpty(strName)) { return false }
    for (var i = 0; i < strName.length; i++) {
      var char = strName.substr(i, 1)
      if (char) {
        const index = SPECIAL_CHARACTER.findIndex(specialChar => specialChar === char)
        if (index > -1) {
          return true
        }
      }
    }
    return false
  }

  /**
   * 获取特殊字符
   * @param {String} str
   * @returns
   */
  static getSpecialCharacter(str) {
    const specialChars = new Map()
    // 中日韩象形文字Unicode编码（CJK）正则：统一表意符号[\u4e00-\u9fbf]、兼容象形文字[\uf900-\ufaff]、
    // 统一表意符号扩展A[\u3400-\u4dbf]、常用标点[\u2000-\u206f]、符号和标点[\u3000-\u303f]、半角及全角形式[\uff00-\uffef]
    const reg = new RegExp('[\u4e00-\u9fbf]|[\uf900-\ufaff]|[\u3400-\u4dbf]|[\u2000-\u206f]|[\u3000-\u303f]|[\uff00-\uffef]|[\u00A0-\u00FF]')
    for (let i = 0; i < str.length; ++i) {
      const c = str[i]
      const code = str.charCodeAt(i)
      if (c.match(reg) || code === 194 || code >= 194 * 256) { // 194、194 * 256对应字符的第一个字节等于-62
        specialChars.set(i, c)
        continue
      }
      for (const sc of SPECIAL_CHARACTER) {
        if (c === sc) {
          specialChars.set(i, c)
          break
        }
      }
    }
    return specialChars
  }

  /**
   * 获取特殊字符串列表
   * @param {String} str
   */
  static getSpecialTexts(str) {
    const result = []
    const map = this.getSpecialCharacter(str)
    let text = ''
    for (let i = 0; i < str.length; ++i) {
      const ch = map.get(i)
      if (ch) {
        text += ch
      } else {
        if (text) {
          result.push(text)
          text = ''
        }
      }
    }
    if (text) {
      result.push(text)
    }
    return result
  }
}
export default StrUtils
